/* eslint-disable */
import Vue from "vue";

Vue.filter("humanize", (value) => {
	if(!value)
		return "";

	if(typeof(value) === "number")
		return moment(value, "x").tz("Europe/Berlin").fromNow();

	return moment(value).tz("Europe/Berlin").fromNow();
});